import { z } from 'zod';
import { SourceStatusSchema } from '../status';
import { ZodStringToDate } from '../system';
export var InvoiceOverviewRateEnum;
(function (InvoiceOverviewRateEnum) {
    InvoiceOverviewRateEnum["INCREASE"] = "INCREASE";
    InvoiceOverviewRateEnum["DECREASE"] = "DECREASE";
})(InvoiceOverviewRateEnum || (InvoiceOverviewRateEnum = {}));
export const InvoiceOverviewRateSchema = z.nativeEnum(InvoiceOverviewRateEnum);
export const InvoiceOverviewSchema = z.object({
    numberOfInvoices: z.number(),
    amount: z.number(),
    percentage: z.number(),
    rate: InvoiceOverviewRateSchema,
});
export const InvoiceListSchema = z.object({
    id: z.string(),
    date: ZodStringToDate,
    dueDate: ZodStringToDate.nullable(),
    amount: z.number(),
    balanceDue: z.number(),
    status: SourceStatusSchema,
    customerName: z.string(),
});
export const InvoicesDataStoreFieldsSchema = z.object({
    outstanding: InvoiceOverviewSchema.nullable(),
    overdue: InvoiceOverviewSchema.nullable(),
    unpaid: InvoiceOverviewSchema.nullable(),
    partial: InvoiceOverviewSchema.nullable(),
    paid: InvoiceOverviewSchema.nullable(),
    invoiceList: InvoiceListSchema.array(),
});
